// src/admin/components/DrawerFooter.tsx
// Sticky action-bar footer for admin drawers — sits outside the scrollable
// content area (a sibling Box, not inside it) so Save/Cancel-style buttons
// stay pinned at the bottom instead of scrolling away with long forms.
// Generalizes the footer pattern that previously only existed locally in
// QuickAddDrawers.tsx's QuickAddShell.
import React from 'react';
import { Box } from '@mui/material';

const DrawerFooter: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box
    sx={{
      display: 'flex', gap: 1, justifyContent: 'flex-end',
      p: 2.5, borderTop: '1px solid', borderColor: 'divider', flexShrink: 0,
    }}
  >
    {children}
  </Box>
);

export default DrawerFooter;
